import { JaarMaandInputType } from "./schema";

export function jaarMaandInMaanden(periode: JaarMaandInputType | null): number | null {
  if (periode && (typeof periode.maanden === "number" || typeof periode.jaren === "number")) {
    return 12 * (periode.jaren || 0) + (periode.maanden || 0);
  }

  return null;
}
